var _ = require('underscore/underscore');

var Page = require('front/pages/Page/Page');

var template = require('./Section.jinja');

var ANIMATION_DURATION = 500;
var VIEW_NAME = 'view';

module.exports = Page.extend({
    //одновременная пропажа и появление сабвьюхи
    collapseSubviewUpdatePlayInOut: true,

    template: template,

    el: '.Section',

    initialize: function (options) {
        _.bindAll(this, 'update');
        Page.prototype.initialize.call(this, options);

        var view = this.options.view;
        this.registerView(VIEW_NAME, new view(_.defaults(this.options.viewData, {
            inAnimated: false,
            server: this.options.server
        })));

        this.$content = this.$el;
    },

    render: function () {
        return Page.prototype.render.call(this);
    },

    viewsRegistration: function () {
    },

    activate: function () {
        return Page.prototype.activate.call(this);
    },

    update: function (view, params) {
        this.options.viewData = params.viewData;
        var prevView;
        var newView;
        prevView = this.getView(VIEW_NAME);

        newView = new view(_.defaults(this.options.viewData, {inAnimated: true, server: false}));

        this.registerView(VIEW_NAME, newView);

        var duration = params.fastNavigate ? 0 : ANIMATION_DURATION;

        if (this.collapseSubviewUpdatePlayInOut) {
            this.loadData()
                .then(function () {
                    return newView.activate();
                })
                .then(function () {
                    return Promise.all([prevView.playOut({
                        duration: duration,
                        zoom: params.zoomNavigate,
                        view: newView
                    }), newView.playIn({duration: duration, zoom: params.zoomNavigate, view: newView})]);
                })
                .then(function () {
                    return prevView.deactivate({destroy: true});
                })
                .then(function () {
                    return newView.activateLogic();
                });
        } else {
            Promise.all([prevView.playOut({
                duration: duration,
                zoom: params.zoomNavigate,
                view: newView
            }), this.loadData()])
                .then(function () {
                    return prevView.deactivate({destroy: true});
                })
                .then(function () {
                    return newView.activate();
                })
                .then(function () {
                    return newView.playIn({duration: duration, zoom: params.zoomNavigate, view: newView});
                });
        }
    },

    deactivate: function (options) {
        return Page.prototype.deactivate.call(this, options);
    },

    loadData: function (viewName) {
        viewName = viewName || 'view';

        return Promise.all([Page.prototype.loadData.call(this), this.getView(viewName).loadData()]);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Section/Section.js
// module id = 62
// module chunks = 0